import * as React from "react";
import { SvgRoot } from "./SvgRoot";

const DeleteIcon = props => {
    // tslint:disable
    return (
        <SvgRoot {...props}>
            <path fill={props.nativeColor} d="M9.4,5.8l0.4-1.6c0.2-0.8,0.7-1.4,1.3-1.4H13c0.6,0,1.1,0.6,1.3,1.4l0.4,1.6"/>
            <g fill="none" stroke={props.nativeColor}>
                <path d="M7.2,7.5l0.5,12c0,0.5,0.5,1,1,1h6.6c0.5,0,1-0.4,1-1l0.4-12"/>
                <line x1="6.5" y1="5.5" x2="17.5" y2="5.5"/>
                <line x1="12" y1="17.8" x2="12" y2="8.5"/>
                <line x1="10" y1="17.8" x2="9.8" y2="8.5"/>
                <line x1="14" y1="17.8" x2="14.3" y2="8.5"/>
            </g>
        </SvgRoot>
    );
};

export default DeleteIcon;


// WEBPACK FOOTER //
// ./src/components/Icons/DeleteIcon.tsx